import { Pipe, PipeTransform } from '@angular/core'
import { Moment } from 'moment-mini'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import moment from 'moment-mini'

@Pipe({
  name: 'getSelectedDateProductFormGroup'
})
export class GetSelectedDateProductFormGroupPipe implements PipeTransform {
  constructor(private fb: UntypedFormBuilder) {}

  transform(
    datesForm: UntypedFormArray,
    bookableProductId: number,
    selectedDate: Moment,
    productId: number
  ): UntypedFormGroup {
    let result: UntypedFormGroup

    for (const control of datesForm.controls as UntypedFormGroup[]) {
      if (result) {
        break
      }

      if (
        moment(control.value['date']).format('YYYY-MM-DD') ===
        selectedDate?.format?.('YYYY-MM-DD')
      ) {
        const formArray: UntypedFormArray = control.controls[
          'products'
        ] as UntypedFormArray

        for (const nestedControl of formArray.controls as UntypedFormGroup[]) {
          if (
            bookableProductId === null &&
            nestedControl.value['productId'] === productId
          ) {
            result = nestedControl
            break
          }

          if (
            nestedControl.value['bookableProductId'] === bookableProductId &&
            nestedControl.value['productId'] === productId
          ) {
            result = nestedControl
            break
          }
        }
      }
    }
    if (!result) {
      return this.fb.group({
        productId: [null],
        bookableProductId: [null],
        qty: [null, [Validators.min(1)]],
        checkIn: [null, []],
        checkOut: [null],
        option: [null],
        note: [null],
        selected: [false],
        hideResource: [null],
        persons: [null],
        maxResourceParticipants: [null]
      })
    }

    return result
  }
}
